import { useQuery } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { ModulosSistemaResponse } from '@/shared/interfaces';

const { get } = erpApi();

export enum ModulosSistemaQueryKeysEnum {
  MODULOS_SYSTEM = 'modulosSistema',
}

///* tanSctack query
export const useFetchModulosSistema = (enabled = true) => {
  return useQuery({
    queryKey: [ModulosSistemaQueryKeysEnum.MODULOS_SYSTEM],
    queryFn: async () => {
      return getModulosSistema();
    },
    enabled,
  });
};

///* axios
export const getModulosSistema = async (): Promise<ModulosSistemaResponse> => {
  return get<ModulosSistemaResponse>(
    `${urlBackend}api/v1/get-modulos`,
    true
  ) as any;
};
